import type { Mixin } from "./define-component.js";
import { PFS_I18N_CHANGED_EVENT } from "../store/i18n-store.js";

// withI18n (PFS-708): der reaktive i18n-Mixin. Ein WC, das ihn in seine mixins
// aufnimmt, re-rendert automatisch, wenn der aktive Katalog wechselt (Loader
// setzt den Katalog / Locale-Switch). In der render()-Funktion nutzt das WC
// `translate(key, default)` — der Rest passiert von selbst.
//
// Komposition, nicht Vererbung — wie withShadow/withContext. Uniform für
// generische pfs-*-WCs UND Cut-App-Domänen-WCs (identische Nutzung).
export function withI18n(): Mixin {
  return (_host, ctx) => {
    const onChange = (): void => ctx.rerender();
    return {
      connect() {
        if (typeof document !== "undefined") {
          document.body?.addEventListener(PFS_I18N_CHANGED_EVENT, onChange);
        }
      },
      disconnect() {
        if (typeof document !== "undefined") {
          document.body?.removeEventListener(PFS_I18N_CHANGED_EVENT, onChange);
        }
      },
    };
  };
}
